import React, { useState, useEffect } from "react";
import { activateAuthLayout } from "../../store/actions";
import { useOktaAuth } from "@okta/okta-react";

import { connect } from "react-redux";
import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import { getQuoteBuilderURL, quoteStatusBadge, getLogoUrl } from "../../helpers/common";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardImg,
} from "reactstrap";
import logo from "../../images/jarvis-icon.png";
import moment from "moment";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import QuotesTable from "../../components/quotes/QuotesTable";

const QUOTES = gql`
  query getQuotes {
    Quotes {
      QuoteId
      ProposalNumber
      CompanyName
      Description
      Status
      WorkflowStep
      QuoteTypeId1
      QuoteTypeId2
      QuoteType1 {
        Name
      }
      QuoteType2 {
        Name
      }
      Created
      ModifiedTimestamp
    }
  }
`;

const RECENT_QUOTES = gql`
  query getRecentQuotes($CreatedBy: String!) {
    RecentQuotes(CreatedBy: $CreatedBy) {
      QuoteId
      ProposalNumber
      CompanyName
      Description
      Status
      WorkflowStep
      QuoteType1 {
        Name
      }
      QuoteType2 {
        Name
      }
      Created
      CustomerLogo
    }
  }
`;

const Dashboard = ({ activateAuthLayout, ...props }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

  const history = useHistory();
  const { data, refetch } = useQuery(QUOTES);
  const [recentQuotes, setRecentQuotes] = useState(null);

  const { authState } = useOktaAuth();
  const userEmail = authState?.idToken?.claims?.email;

  const { data: recentQuoteData } = useQuery(RECENT_QUOTES, {
    variables: { CreatedBy: userEmail },
    skip: !userEmail,
  });

  const QUOTE_TYPES_BADGE_CLASSES = {
    CAPEX: "badge-primary",
    OPEX: "badge-info",
    ENERDS: "badge-danger",
  };

  useEffect(() => {
    if (recentQuoteData) {
      const { RecentQuotes = [] } = recentQuoteData || {};
      setRecentQuotes(RecentQuotes);
    }
  }, [recentQuoteData]);


  return (
    <div className="content">
      <div className="container-fluid">
        <Row className="pt-5 mb-5">
          <Col className="d-flex align-items-center" xs={9}>
            <div className="dashboard-logo-container">
              <img src={logo} className="img-fluid" alt="" />
            </div>
            <div className="page-title-box">
              <h4 className="page-title">Welcome to JARVIS</h4>
              <p className="mb-0">Select a quote from below, or click create new to get started</p>
            </div>
          </Col>
          <Col>
            <button
              className="btn btn-success btn-lg pull-right"
              onClick={(e) => {
                e.preventDefault();
                history.push('/new-quote');
              }}
            >
              Create New Quote
            </button>
          </Col>
        </Row>
        {recentQuotes && recentQuotes.length > 0 && (
          <>
            <h5 className="mb-3">My Recent Quotes</h5>
            <Row>
              {recentQuotes.map((quote) => {
                  let customerLogo = quote.CustomerLogo ? getLogoUrl(quote.CustomerLogo) : logo;
                  const quoteURL = getQuoteBuilderURL(quote.WorkflowStep, quote.QuoteId);
                  return (
                    <Col
                      key={Math.round(Math.random() * 999999999)}
                      className="quote-item-display"
                    >
                      <Card>
                        <CardImg
                          variant="top"
                          src={customerLogo}
                          style={{
                            width: "120px",
                            height: "120px",
                            margin: "20px auto",
                            objectFit: "cover",
                          }}
                        />
                        <span className="quote-company-name">
                          {quote.CompanyName}
                        </span>
                        <span className="quote-description">
                          {quote.Description}
                        </span>
                        <CardBody className="quote-body-description">
                          <Row>
                            <Col>Quote No.</Col>
                            <Col>{quote.ProposalNumber}</Col>
                          </Row>
                          <Row>
                            <Col>Status</Col>
                            <Col>{quoteStatusBadge(quote.Status)}</Col>
                          </Row>
                          <Row>
                            <Col>Created</Col>
                            <Col>{moment(quote.Created).fromNow()}</Col>
                          </Row>
                          <Row>
                            <Col>Quote 1 Type</Col>
                            <Col>
                              {quote.QuoteType1 && (
                                <span className={`badge badge-pill ${QUOTE_TYPES_BADGE_CLASSES[quote.QuoteType1.Name]}`}>
                                  {quote.QuoteType1.Name}
                                </span>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col>Quote 2 Type</Col>
                            <Col>
                              {quote.QuoteType2 && (
                                <span className={`badge badge-pill ${QUOTE_TYPES_BADGE_CLASSES[quote.QuoteType2.Name]}`}>
                                  {quote.QuoteType2.Name}
                                </span>
                              )}
                            </Col>
                          </Row>
                          <Row className="pt-4">
                            <Col>
                              <Link
                                className="btn btn-info btn-block"
                                to={quoteURL}
                              >
                                Open Quote
                              </Link>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
            </Row>
          </>
        )}
        <h5 className="mb-3">All Quotes</h5>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <QuotesTable quotes={data?.Quotes} refetch={refetch} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default connect(null, { activateAuthLayout })(Dashboard);
